// extracted by mini-css-extract-plugin
export default {"toggle":"toggle---h71bC"};